import(/* webpackMode: "eager", webpackExports: ["Result","Button"] */ "__barrel_optimize__?names=Button,Result!=!/vercel/path0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/not-found.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ProductAnalyticsProvider"] */ "/vercel/path0/src/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/contexts/ThemeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/libs/AntDesignConfig.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/css/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/css/antdesign.custom.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/img/logo_partsflow_white.png");
